import React from 'react';
import { ChatWidgetDrawer } from './ChatWidgetDrawer';
import { mockConversations } from '../../__fixtures__/conversations';
const meta = {
    title: 'Features/AIChatWidget/ChatWidgetDrawer',
    component: ChatWidgetDrawer,
    decorators: [
        (Story) => (React.createElement("div", { style: { height: '100vh', width: 192, border: '1px solid #DBDBE4', borderRadius: 8, overflow: 'hidden' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const Default = {
    args: {
        conversations: mockConversations,
        activeConversationId: null,
        isLoading: false
    }
};
export const WithActiveConversation = {
    args: {
        conversations: mockConversations,
        activeConversationId: 'conv-1',
        isLoading: false
    }
};
export const Loading = {
    args: {
        conversations: [],
        activeConversationId: null,
        isLoading: true
    }
};
export const Empty = {
    args: {
        conversations: [],
        activeConversationId: null,
        isLoading: false
    }
};
